module.exports = __webpack_public_path__ + "static/media/nutrizones_footer_bg.f9cb6913.png";